import { CloseReason } from "../interfaces/orden.interface";

export const INVALID_MESSAGES = [
  'La orden de pago ha expirado.',
  'La orden de pago, ya ha sido procesada.'
]

export const CLOSE_MESSAGES: Record<CloseReason, string> = {
  success: 'El pago se completó y el flujo regresa a la app.',
  cancelled: 'El usuario canceló.',
  expired: 'La orden expiró o es inválida.',
  error: 'El flujo terminó por un error.',
  userDismissed : 'El usuario cerró el WebView manualmente sin completar el pago.'
};
